import { EXPERIMENT_COOKIE_NAME, EXPERIMENT_ORIGIN_HASH_COOKIE_NAME } from '../constants';
import { CookieUtils } from '../types/cookies_utils';
import Identifier from './identifiers';

class Experimentation {
  constructor(
    private readonly identifier: Identifier,
    private readonly cookieUtils: CookieUtils,
  ) {}

  getExperimentationId() {
    // This does nothing if valid vi cookie has been set already
    this.identifier.authorizeIdentifier(EXPERIMENT_COOKIE_NAME);

    return this.cookieUtils.getCookie(EXPERIMENT_COOKIE_NAME);
  }

  getExperimentationIdOriginHash() {
    const cookie = this.cookieUtils.getCookie(EXPERIMENT_ORIGIN_HASH_COOKIE_NAME);

    return cookie && decodeURIComponent(cookie);
  }

  checkResetExperimentationId(userId: string) {
    return this.identifier.checkResetIdentifier(
      userId,
      EXPERIMENT_ORIGIN_HASH_COOKIE_NAME,
      EXPERIMENT_COOKIE_NAME,
    );
  }
}

export default Experimentation;
